import { useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';

type WithBetaModulesChildren = (betaModules: string[]) => any;

type WithBetaModulesProps = {
  children: WithBetaModulesChildren;
};

function WithBetaModules({ children }: WithBetaModulesProps) {
  const [betaModules] = useObservable(() => eduzzAccountsService.getBetaModules(), []);
  return children(betaModules);
}

export default WithBetaModules;
